(function($) {

	'use strict';

	var init = function() {

        videoResize();

    }

    var videoResize = function() {

        $('#hero-transform').mouseenter(function() {
            $('.fp-hero__video').addClass('scale');
        });

        $('#hero-transform').mouseleave(function() {
            $('.fp-hero__video').removeClass('scale');
        });

        var videoMini = document.getElementById('hero-video-mini');

        var windowPosition = 0;

        $('#hero-lightbox-fullscreen').click(function() {

            windowPosition = $(window).scrollTop();

            $('#hero-lightbox').addClass('active');

            $('body').addClass('fullscreen');

            videoMini.pause();

        });

        $('#hero-lightbox-close').click(function() {

            $('#hero-lightbox').removeClass('active');

            $('body').removeClass('fullscreen');

            $("html, body").scrollTop(windowPosition);

            videoMini.play();

        });

        
    }

	$(document).ready(function() {
		init();
	});

})(jQuery);